import React, { Fragment, PureComponent, useCallback, useEffect, useState } from 'react';
import { NavLink, Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom';
import { ActionButton, BaseButton, Button, ChoiceGroup, DefaultButton, Dialog, DialogFooter, DialogType, DirectionalHint, Dropdown, DropdownMenuItemType, IChoiceGroupOption, Icon, IDropdownOption, Label, Panel, PanelType, PrimaryButton, Shimmer, Spinner, SpinnerSize, TextField, Toggle, TooltipHost } from 'office-ui-fabric-react';
import { ulid } from 'ulid';

import { WsDecodeBoardInterface, WsDecodeData, WsDecodeMetric, WsDecodeSource } from '../../../../../core/src/interfaces';

import { apiGet, apiPost } from '../../../helpers-sales';

import { WsDecodeScoreView, WsDecodeClassification, WsDecodeMeasurement, WsSalesOrganizationType, getScoreView } from '../../../enums';

import { generateDataValueList, getBoardScorePercent, getDataValueListFromDataList, getLabelList, getMetricScore, getMetricStatistic, getMetricValueString, getMetricValueStringPercent, getScoreValue, WsDecodeCard, WsMetricStatistic } from './decode-data';

import { WsDecodeFieldFinder, WsDecodeLinkBoardDialog } from './DecodeMetrics';

import { getBoardMetricOptions } from '../../../decode-helpers';

import { defaultValue, isNumeric } from '../../../helpers';

import { WsNumberField } from '../../Controls/Form/NumberField';

import { Loading } from '../../Shared';




type WsMetricDialogProps = {
  boardId: string;
  metric:   WsDecodeMetric;
  onCancel: () => void;
  onSave:   (metric: WsDecodeMetric) => void;
};

const WsDecodeMetricDialog = (props: WsMetricDialogProps) => {

  const [ newSource, setNewSource ] = useState<WsDecodeSource | undefined>(undefined);

  const [ metric, setMetric ] = useState<WsDecodeMetric>({ ...props.metric });



  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.onCancel();
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onCancel();
  };

  const onClickSave = async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {

    if (newSource) {
      console.log('NEW SOURCE');

      if (newSource.dataSource && newSource.dataTable && newSource.dataField) {

        const createSourceItem = await apiPost(`/decode/source-list`, { ...newSource });

        if (createSourceItem && createSourceItem.sourceItem) {
          console.log(createSourceItem.sourceItem);
        }
      }

    } else {
      console.log('EXISTING SOURCE');
    }

    props.onSave(metric);
  };





  const [ panel, setPanel ] = useState<( number | string | boolean )[] | undefined>(undefined);





  const [ dataList, setDataList ] = useState<WsDecodeData[] | undefined>(undefined);

  const loadDataList = useCallback(async () => {

    const result = await apiGet(`/decode/data-list`);

    if (result && Array.isArray(result.dataList)) {
      const resultData = result.dataList as WsDecodeData[];
      // console.log(resultData);
      setDataList(resultData);
    }

  }, []);

  useEffect(() => {
    loadDataList();
  }, []);



  const [ sourceList, setSourceList ] = useState<WsDecodeSource[] | undefined>(undefined);

  const loadData = useCallback(async () => {

    const result = await apiGet(`/decode/source-list`);

    if (result && Array.isArray(result.sourceList)) {
      const resultData = result.sourceList as WsDecodeSource[];
      // console.log(resultData);
      setSourceList(resultData);
    }

  }, []);

  useEffect(() => {
    loadData();
  }, []);



  const [ boardList, setBoardList ] = useState<WsDecodeBoardInterface[] | undefined>(undefined);

  const loadBoards = useCallback(async () => {

    const result = await apiGet(`/decode/boards`);

    if (result && Array.isArray(result.decodeBoardList)) {
      const resultData = result.decodeBoardList as WsDecodeBoardInterface[];
      // console.log(resultData);
      setBoardList(resultData);
    }

  }, []);

  useEffect(() => {
    loadBoards();
  }, []);



  // console.log('--------------------------------------------------------------------------------');
  // console.log('- WsDecodeMetricDialog ---------------------------------------------------------');

  // console.log(sourceList);

  // console.log(metric);



  const sourceItem = sourceList?.find((item) => item.id === metric.sourceId);

  const dataValueList: ( number | string | boolean )[] = sourceItem ? sourceItem.dataValueList : [];

  const metricStatistic = getMetricStatistic(sourceList || [], boardList || [], metric, dataValueList);



  // console.log(sourceItem);

  // console.log(metricStatistic);



  // console.log(panel);

  const sourceItemForPanel = newSource ? newSource : sourceItem;

  console.log('sourceItemForPanel');
  console.log(sourceItemForPanel);



  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        title: metric.id ? `Edit Metric` : `Add Metric`,
        type: DialogType.normal
      }}
      modalProps={{
        className: panel ? 'ws-decode-metrics-dialog ws-decode-metrics-dialog-data-preview' : 'ws-decode-metrics-dialog',
        isBlocking: false,
        styles: {
          // main: { width: 700 }
        }
      }}
    >
      {
        (
          dataList
          &&
          sourceList
          &&
          boardList
        )
        ?
        <>
          <Fragment>

            <div className="ws-decode-metric-form">

              <div className="columns">

                <div className="column">



                  {/* choice: existing or new */}

                  <>
                    <ChoiceGroup
                      options={[
                        { key: 'EXISTING', text: 'Use Existing Metric' },
                        { key: 'NEW',      text: 'Create New Metric'   },
                      ]}
                      onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {

                        if (option?.key === 'NEW') {

                          const newSourceId = ulid();

                          const newSourceItem: WsDecodeSource = {
                            id:             newSourceId,
                            name:           metric.name,
                            dataSource:     '',
                            dataTable:      '',
                            dataField:      '',
                            dataType:       '',
                            dataValue:      0,
                            dataValueList:  [], // generateDataValueList(),
                            classification: WsDecodeClassification.None
                          };

                          setNewSource(newSourceItem);

                          const nextMetric = { ...metric };
                          nextMetric.parentId = newSourceId;
                          nextMetric.sourceId = newSourceId;
                          setMetric(nextMetric);

                        } else {

                          setNewSource(undefined);

                          const nextMetric = { ...metric };
                          nextMetric.parentId = '';
                          nextMetric.sourceId = '';
                          setMetric(nextMetric);
                        }
                      }}
                      selectedKey={ newSource ? 'NEW' : 'EXISTING' }
                    />
                  </>



                  {
                    newSource
                    ?
                    <>
                      <br />
                      <WsDecodeFieldFinder
                        selectedFieldId={`${newSource.dataTable}.${newSource.dataField}`}
                        setSelectedField={(dataTable: string, dataField: string, dataType: string) => {

                          const nextSource = { ...newSource };
                          nextSource.dataSource   = 'DECODE';
                          nextSource.dataTable    = dataTable;
                          nextSource.dataField    = dataField;
                          nextSource.dataType     = dataType;

                          nextSource.dataValueList = getDataValueListFromDataList(dataList, dataTable, dataField);

                          console.log('nextSource.dataValueList');
                          console.log(nextSource.dataValueList);

                          setNewSource(nextSource);

                          const nextMetric = { ...metric };
                          nextMetric.parentId = nextSource.id;
                          nextMetric.sourceId = nextSource.id;
                          setMetric(nextMetric);
                        }}
                      />
                      <br />
                    </>
                    :
                    <>
                      <br />
                      <Dropdown
                        label={`Metric`}
                        options={
                          getBoardMetricOptions(sourceList, boardList, props.boardId)
                          .concat(
                            [
                              { key: 'METRICS', text: 'Metrics', itemType: DropdownMenuItemType.Header }
                            ]
                          )
                          .concat(
                            sourceList
                            .filter((item) => !item.deletedAt || item.id === metric.sourceId)
                            .sort((a, b) => {

                              if (a && b) {

                                if (`${a.deletedAt}` > `${b.deletedAt}`) return -1;
                                if (`${a.deletedAt}` < `${b.deletedAt}`) return  1;

                                if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
                                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;

                                return 0;

                              } else {
                                return 0;
                              }
                            })
                            .map((sourceItem): IDropdownOption => {
                              return { key: sourceItem.id, text: sourceItem.deletedAt ? `[DELETED] ${sourceItem.name}` : `${sourceItem.name}` };
                            })
                          )
                        }
                        onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                          if (option) {

                            const nextMetric = { ...metric };

                            nextMetric.parentId = `${option.key}`;
                            nextMetric.sourceId = `${option.key}`;

                            setMetric(nextMetric);
                          }
                        }}
                        placeholder="Select Metric"
                        selectedKey={metric.sourceId}
                      />

                      <br />

                      {
                        isNumeric(metric.sourceId)
                        ?
                        <><b>Metric Source:</b> Board<br /><br /></>
                        :
                        <>
                          <div className="columns">
                            <div className="column is-1">
                              <b>Field:</b>
                            </div>
                            <div className="column is-3">
                              {sourceItem?.dataField || '-'}
                            </div>

                            <div className="column is-1">
                              <b>Type:</b>
                            </div>
                            <div className="column is-2">
                              {sourceItem?.dataType|| '-'}
                            </div>

                            <div className="column is-1">
                              <b>Table:</b>
                            </div>
                            <div className="column is-4">
                              {sourceItem?.dataTable|| '-'}
                            </div>
                          </div>
                        </>
                      }
                    </>
                  }



                  {/* metric name */}

                  <>
                    <TextField
                      label="Metric Name"
                      placeholder="Metric Name"
                      onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
                        const nextMetric = { ...metric };

                        if (newValue) {
                          nextMetric.name = newValue;
                        } else {
                          nextMetric.name = '';
                        }

                        if (newSource) {
                          const nextSource = { ...newSource };
                          nextSource.name = nextMetric.name;
                          setNewSource(nextSource);
                        }

                        setMetric(nextMetric);
                      }}
                      value={metric.name}
                    />
                  </>



                  <br />



                  <div className="columns">



                    {/* metric measurement */}

                    <div className="column is-4">

                      {
                        isNumeric(metric.sourceId)
                        ?
                        <>
                          <Label>Measurement</Label>
                          Board
                        </>
                        :
                        <>
                          <Label>Measurement</Label>
                          <ChoiceGroup
                            className="ws-decode-metric-measurement"
                            style={{
                              marginTop: '-7px'
                            }}
                            options={[
                              { key: 'AVERAGE', text: 'Average' },
                              { key: 'COUNT',   text: 'Count'   },
                              { key: 'SUM',     text: 'Sum'     },
                            ]}
                            onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {
                              if (option) {
                                const nextMetric = { ...metric };

                                if (option.key === 'COUNT') {
                                  nextMetric.measurement = WsDecodeMeasurement.Count;
                                } else if (option.key === 'SUM') {
                                  nextMetric.measurement = WsDecodeMeasurement.Sum;
                                } else {
                                  nextMetric.measurement = WsDecodeMeasurement.Average;
                                }

                                setMetric(nextMetric);
                              }
                            }}
                            selectedKey={ metric.measurement }
                          />
                        </>
                      }



                      {/* metric - static value */}

                      {
                        isNumeric(metric.sourceId)
                        ?
                        <></>
                        :
                        <>

                          <br />
                          <br />

                          <Label>Static Value</Label>
                          <WsNumberField
                            className="ws-input-number input is-normal"
                            organization={WsSalesOrganizationType.Avanade}
                            min={0}
                            max={10000}
                            size={4}
                            precision={0}
                            onChange={(value: number | null, stringValue: string, input: HTMLInputElement) => {
                              const nextMetric = { ...metric };

                              if (value !== null && !isNaN(value)) {
                                if (value < 0) {
                                  nextMetric.staticValue = 0;
                                } else if (value > 10000) {
                                  nextMetric.staticValue = 10000;
                                } else {
                                  nextMetric.staticValue = value;
                                }
                              } else {
                                nextMetric.staticValue = 0;
                              }

                              setMetric(nextMetric);
                            }}
                            value={metric.staticValue || 0}
                          />
                        </>
                      }
                    </div>



                    {/* metric - converted value */}

                    <div className="column is-2">
                      <Label style={{ marginBottom: '4px' }}>Converted Value</Label>
                      {metricStatistic.convertedValue.toFixed(1)}
                    </div>



                    {/* metric - baseline */}

                    <div className="column is-2" style={{ paddingLeft: '20px' }}>

                      {
                        isNumeric(metric.sourceId)
                        ?
                        <>
                          <Label>Baseline</Label>
                          10.0
                        </>
                        :
                        <>
                          <Label>Baseline</Label>
                          <WsNumberField
                            className="ws-input-number input is-normal"
                            organization={WsSalesOrganizationType.Avanade}
                            min={0}
                            max={10000}
                            size={4}
                            precision={0}
                            onChange={(value: number | null, stringValue: string, input: HTMLInputElement) => {
                              const nextMetric = { ...metric };

                              if (value !== null && !isNaN(value)) {
                                if (value < 0) {
                                  nextMetric.baselineValue = 0;
                                } else if (value > 10000) {
                                  nextMetric.baselineValue = 10000;
                                } else {
                                  nextMetric.baselineValue = value;
                                }
                              } else {
                                nextMetric.baselineValue = 0;
                              }

                              setMetric(nextMetric);
                            }}
                            value={metric.baselineValue || 0}
                          />
                        </>
                      }
                    </div>



                    {/* metric - weight */}

                    <div className="column is-2">



                      <Label>Weighting</Label>

                      <WsNumberField
                        className="ws-input-number input is-normal"
                        organization={WsSalesOrganizationType.Avanade}
                        min={0}
                        max={100}
                        size={4}
                        precision={0}
                        onChange={(value: number | null, stringValue: string, input: HTMLInputElement) => {
                          const nextMetric = { ...metric };

                          if (value !== null && !isNaN(value)) {
                            if (value < 0) {
                              nextMetric.weight = 0;
                            } else if (value > 100) {
                              nextMetric.weight = 100;
                            } else {
                              nextMetric.weight = value;
                            }
                          } else {
                            nextMetric.weight = 0;
                          }

                          setMetric(nextMetric);
                        }}
                        value={metric.weight || 100}
                      />
                    </div>



                    {/* metric - value */}

                    {/*
                      metric.value            *virtual (converted value based on measurement)
                      metric.staticValue

                      metric.baselineValue

                      metric.calculatedValue  *virtual
                      metric.viewValue        *virtual
                    */}

                    <div className="column is-2">

                      <Label style={{ marginBottom: '4px' }}>Value</Label>

                      {getMetricScore(metricStatistic, metric.scoreView)}

                      <br />
                      <br />

                      <div
                        style={{
                          width: 100
                        }}
                      >
                        <ChoiceGroup
                          label="View"

                          options={[
                            { key: 'SCORE',   text: 'Score'   },
                            { key: 'PERCENT', text: 'Percent' },
                            { key: 'VALUE',   text: 'Value'   }
                          ]}

                          onChange={(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, option?: IChoiceGroupOption) => {
                            const nextMetric = { ...metric };

                            if (option?.key === 'VALUE') {
                              nextMetric.scoreView = WsDecodeScoreView.Value;   // value
                            } else if (option?.key === 'PERCENT') {
                              nextMetric.scoreView = WsDecodeScoreView.Percent; // percent
                            } else {
                              nextMetric.scoreView = WsDecodeScoreView.Score;   // score
                            }

                            setMetric(nextMetric);
                          }}

                          selectedKey={getScoreView(metric.scoreView)}
                        />

                      </div>

                    </div>

                  </div>

                  <br />

                </div>
              </div>
            </div>
          </Fragment>

          <DialogFooter>
            <>
              <DefaultButton
                onClick={() => {
                  setPanel(sourceItemForPanel ? sourceItemForPanel.dataValueList : [])
                }}
                text="Data Preview"
                style={{ marginRight: '5px' }}
              />
              <DefaultButton onClick={onClickCancel} text="Cancel" />
              <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} disabled={(metric.name && (newSource ? (newSource.dataSource && newSource.dataTable && newSource.dataField) : metric.sourceId)) ? false : true} />
            </>
          </DialogFooter>

          {
            panel
            &&
            <>
              <Panel
                customWidth="500px"
                isBlocking={false}
                isOpen={true}
                onDismiss={() => {
                  setPanel(undefined);
                }}
                type={PanelType.custom}
              >
                <h2 className="title is-4">Data Preview ({ sourceItemForPanel && sourceItemForPanel.dataValueList ? sourceItemForPanel.dataValueList.length :  0 } records)</h2>

                {
                  process.env.NODE_ENV === 'development'
                  &&
                  <>
                    {`${ typeof sourceItemForPanel }`}<br />
                    table: {sourceItemForPanel?.dataTable}<br />
                    field: {sourceItemForPanel?.dataField}<br />
                  </>
                }

                <table className="table is-fullwidth">
                  <thead>
                    <tr>
                      <th>Data Values</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {sourceItemForPanel?.dataValueList.map((val, ind) => {
                      return (
                        <tr key={`ws-dfsnjids-${ind}`}><td>{val}</td></tr>
                      );
                    })} */}
                    {
                      sourceItemForPanel
                      ?
                      <>
                        {
                          getDataValueListFromDataList(dataList, sourceItemForPanel.dataTable, sourceItemForPanel.dataField).map((dataValue, index) => {
                            return (
                              <tr key={`ws-decode-data-value-${index}`}>
                                <td>{`${dataValue}` || '(blank value)'}</td>
                              </tr>
                            )
                          })
                        }
                      </>
                      :
                      <>No Data!</>
                    }
                  </tbody>
                </table>
              </Panel>
            </>
          }
        </>
        :
        <>
          <Loading />
          <br />
          <br />
        </>
      }
    </Dialog>
  );
};




export {
  WsDecodeMetricDialog
};
